const compareGmailLocalParts = (local1: string, local2: string) => {
  const gmailLocal1 = local1.replace(/\./g, "")
  const gmailLocal2 = local2.replace(/\./g, "")
  const plusIndex1 = gmailLocal1.indexOf("+")
  const plusIndex2 = gmailLocal2.indexOf("+")

  const baseLocal1 = plusIndex1 !== -1 ? gmailLocal1.slice(0, plusIndex1) : gmailLocal1
  const baseLocal2 = plusIndex2 !== -1 ? gmailLocal2.slice(0, plusIndex2) : gmailLocal2

  return baseLocal1 === baseLocal2
}

export const normalizeEmail = (email: string) => email.toLowerCase().trim()

export const compareEmails = (email1: string, email2: string, strict = true) => {
  const normalized1 = normalizeEmail(email1)
  const normalized2 = normalizeEmail(email2)
  if (strict || normalized1 === normalized2) {
    return normalized1 === normalized2
  }

  const [local1 = "", domain1] = normalized1.split("@")
  const [local2 = "", domain2 = ""] = normalized2.split("@")

  if (domain1 !== domain2) {
    return false
  }

  if (domain1 === "gmail.com") {
    return compareGmailLocalParts(local1, local2)
  }

  return false
}

const levenshteinDistance = (value1: string, value2: string, maxDistance: number) => {
  const len1 = value1.length
  const len2 = value2.length

  if (Math.abs(len1 - len2) > maxDistance) {
    return maxDistance + 1
  }

  const prev = new Array(len2 + 1).fill(0)
  const next = new Array(len2 + 1).fill(0)

  for (let j = 0; j <= len2; j += 1) {
    prev[j] = j
  }

  for (let i = 1; i <= len1; i += 1) {
    next[0] = i
    let rowMin = next[0]
    const char1 = value1[i - 1]

    for (let j = 1; j <= len2; j += 1) {
      const cost = char1 === value2[j - 1] ? 0 : 1
      next[j] = Math.min(prev[j] + 1, next[j - 1] + 1, prev[j - 1] + cost)
      rowMin = Math.min(rowMin, next[j])
    }

    if (rowMin > maxDistance) {
      return maxDistance + 1
    }

    for (let j = 0; j <= len2; j += 1) {
      prev[j] = next[j]
    }
  }

  return prev[len2]
}

export const compareSimilarEmails = (email1: string, email2: string, maxDistance = 1) => {
  const normalized1 = normalizeEmail(email1)
  const normalized2 = normalizeEmail(email2)

  if (normalized1 === normalized2) {
    return true
  }

  if (maxDistance <= 0) {
    return false
  }

  return levenshteinDistance(normalized1, normalized2, maxDistance) <= maxDistance
}

// Message.source marker for an inbound reply on a known thread sent from an address other than the
// conversation's customer (a third party). Carries the actual sender so the UI can surface it.
const SOURCE_EMAIL_PREFIX = "email:"

export const buildEmailSource = (email: string) => `${SOURCE_EMAIL_PREFIX}${email}`

export const parseEmailSource = (source: string | null | undefined) =>
  source?.startsWith(SOURCE_EMAIL_PREFIX) ? source.slice(SOURCE_EMAIL_PREFIX.length) : null
